// Theme JavaScript

document.addEventListener('DOMContentLoaded', () => {
  initAddToCartButtons();
  initCartDrawer();
  initAddToCartForms();
  initSubscribeButtons();
  initNewsletterForms();
});

// Initialize add to cart functionality
function initAddToCartButtons() {
  const addToCartButtons = document.querySelectorAll('.js-add-to-cart');
  
  if (addToCartButtons.length > 0) {
    addToCartButtons.forEach(button => {
      button.addEventListener('click', handleAddToCart);
    });
  }
}

// Initialize add to cart forms
function initAddToCartForms() {
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      // Get submit button and set loading state
      const submitButton = form.querySelector('[type="submit"]');
      let originalText = '';
      
      if (submitButton) {
        originalText = submitButton.textContent;
        submitButton.textContent = 'Adding...';
        submitButton.disabled = true;
      }
      
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Reset button
        if (submitButton) {
          submitButton.textContent = 'Added!';
        }
        
        // Update cart count and open drawer
        updateCartCount();
        
        if (window.cartDrawerFunctions && window.cartDrawerFunctions.open) {
          window.cartDrawerFunctions.open();
        }
        
        // Reset button after delay
        setTimeout(() => {
          if (submitButton) {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }
        }, 2000);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Reset button
        if (submitButton) {
          submitButton.textContent = 'Error - Try Again';
          
          setTimeout(() => {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }, 2000);
        }
      });
    });
  });
}

// Initialize cart drawer
function initCartDrawer() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');
  const cartButtons = document.querySelectorAll('[data-cart-drawer-open]');
  const closeButtons = document.querySelectorAll('[data-cart-drawer-close]');
  
  // Function to open cart drawer
  function openCartDrawer() {
    if (cartDrawer && cartDrawerOverlay) {
      cartDrawer.classList.add('active');
      cartDrawerOverlay.classList.add('active');
      document.body.classList.add('drawer-open');
    }
  }
  
  // Function to close cart drawer
  function closeCartDrawer() {
    if (cartDrawer && cartDrawerOverlay) {
      cartDrawer.classList.remove('active');
      cartDrawerOverlay.classList.remove('active');
      document.body.classList.remove('drawer-open');
    }
  }
  
  // Add click event listeners to cart buttons
  cartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  });
  
  // Add click event listeners to close buttons
  closeButtons.forEach(button => {
    button.addEventListener('click', closeCartDrawer);
  });
  
  // Close drawer when clicking on overlay
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }
  
  // Close drawer with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
    }
  });

  // Make functions available globally
  window.cartDrawerFunctions = {
    open: openCartDrawer,
    close: closeCartDrawer
  };
}

// Handle add to cart button click
function handleAddToCart(event) {
  event.preventDefault();
  
  const button = event.currentTarget;
  const variantId = button.dataset.variantId;
  
  if (!variantId) {
    console.error('No variant ID found for add to cart');
    return;
  }
  
  // Set button to loading state
  const originalText = button.textContent;
  button.textContent = 'Adding...';
  button.disabled = true;
  
  // Add to cart using Shopify AJAX API
  addItemToCart(variantId, 1)
    .then(cartItem => {
      // Success - update button text temporarily
      button.textContent = 'Added!';
      
      // Update cart count/drawer if needed
      updateCartCount();
      
      // Open cart drawer
      if (window.cartDrawerFunctions && window.cartDrawerFunctions.open) {
        window.cartDrawerFunctions.open();
      }
      
      // Reset button after delay
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    })
    .catch(error => {
      // Error - show message and reset button
      console.error('Error adding to cart:', error);
      button.textContent = 'Error - Try Again';
      
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    });
}

// Add item to cart via Shopify AJAX API
function addItemToCart(id, quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id,
      quantity
    })
  })
  .then(response => {
    return response.json();
  });
}

// Update cart count in header
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update any cart count elements
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        
        if (cart.item_count === 0) {
          element.classList.add('hide');
        } else {
          element.classList.remove('hide');
        }
      });
      
      // Update cart drawer if it exists
      updateCartDrawer(cart);
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

// Update cart drawer with new content
function updateCartDrawer(cart) {
  // If we have no items, refresh the drawer content completely
  if (cart.item_count === 0) {
    const cartDrawerItems = document.querySelector('.cart-drawer__items');
    if (cartDrawerItems) {
      cartDrawerItems.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p></div>';
    }
    
    const cartDrawerFooter = document.querySelector('.cart-drawer__footer');
    if (cartDrawerFooter) {
      cartDrawerFooter.style.display = 'none';
    }
    
    return;
  }
  
  // Now we have items in the cart - update the cart drawer with actual items
  
  // Make sure the footer is displayed
  const cartDrawerFooter = document.querySelector('.cart-drawer__footer');
  if (cartDrawerFooter) {
    cartDrawerFooter.style.display = 'block';
  }

  // Update cart items
  const cartDrawerItems = document.querySelector('.cart-drawer__items');
  if (cartDrawerItems) {
    // Create a loading indicator
    cartDrawerItems.innerHTML = '<div class="cart-drawer__loading">Loading cart items...</div>';
    
    // Fetch cart page section to get the rendered HTML
    fetch('/?sections=cart-drawer')
      .then(response => response.text())
      .then(responseText => {
        // Parse the response JSON
        const data = JSON.parse(responseText);
        
        if (data['cart-drawer']) {
          // Extract just the cart items HTML from the response
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data['cart-drawer'];
          
          // Get the cart content
          const cartContent = tempDiv.querySelector('.cart-drawer__content');
          
          if (cartContent) {
            // Replace the entire cart drawer content
            const drawerBody = document.querySelector('.cart-drawer__body');
            if (drawerBody) {
              drawerBody.innerHTML = cartContent.innerHTML;
              
              // Re-attach event listeners for quantity inputs and remove buttons
              attachCartItemEvents();
            }
          } else {
            // Fallback if we couldn't find the content
            console.error('Could not find cart drawer content in the response');
            cartDrawerItems.innerHTML = `<div class="cart-drawer__summary">Your cart has ${cart.item_count} item(s)</div>`;
          }
        }
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
        // Fallback: Just display item count
        cartDrawerItems.innerHTML = `<div class="cart-drawer__summary">Your cart has ${cart.item_count} item(s)</div>`;
      });
  }
  
  // Update subtotal
  const subtotalElement = document.querySelector('[data-cart-subtotal]');
  if (subtotalElement) {
    subtotalElement.textContent = formatMoney(cart.total_price);
  }
}

// Attach event listeners to cart item elements
function attachCartItemEvents() {
  // Quantity buttons
  const quantityMinusButtons = document.querySelectorAll('[data-cart-quantity-minus]');
  const quantityPlusButtons = document.querySelectorAll('[data-cart-quantity-plus]');
  const quantityInputs = document.querySelectorAll('[data-cart-quantity]');
  const removeButtons = document.querySelectorAll('[data-cart-remove]');
  
  // Quantity minus buttons
  quantityMinusButtons.forEach(button => {
    button.addEventListener('click', function() {
      const input = this.closest('.quantity-selector').querySelector('[data-cart-quantity]');
      let value = parseInt(input.value) - 1;
      if (value < 1) value = 1;
      input.value = value;
      updateCartItemQuantity(this.closest('[data-cart-item]').dataset.cartItemKey, value);
    });
  });
  
  // Quantity plus buttons
  quantityPlusButtons.forEach(button => {
    button.addEventListener('click', function() {
      const input = this.closest('.quantity-selector').querySelector('[data-cart-quantity]');
      let value = parseInt(input.value) + 1;
      input.value = value;
      updateCartItemQuantity(this.closest('[data-cart-item]').dataset.cartItemKey, value);
    });
  });
  
  // Quantity inputs
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      let value = parseInt(this.value);
      if (isNaN(value) || value < 1) value = 1;
      this.value = value;
      updateCartItemQuantity(this.closest('[data-cart-item]').dataset.cartItemKey, value);
    });
  });
  
  // Remove buttons
  removeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const itemKey = this.closest('[data-cart-item]').dataset.cartItemKey;
      updateCartItemQuantity(itemKey, 0);
    });
  });
}

// Update cart item quantity
function updateCartItemQuantity(key, quantity) {
  // Find the item element to update UI
  const itemElement = document.querySelector(`[data-cart-item-key="${key}"]`);
  if (!itemElement) return;
  
  // Get UI elements
  const minusButton = itemElement.querySelector('[data-cart-quantity-minus]');
  const plusButton = itemElement.querySelector('[data-cart-quantity-plus]');
  const input = itemElement.querySelector('[data-cart-quantity]');
  
  // Add loading state
  if (input) {
    input.classList.add('loading');
    input.disabled = true;
  }
  if (minusButton) minusButton.disabled = true;
  if (plusButton) plusButton.disabled = true;
  
  // If removing item (quantity = 0), add visual indication
  if (quantity === 0 && itemElement) {
    itemElement.style.opacity = '0.5';
  }
  
  const data = {
    id: key,
    quantity: quantity
  };
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(cart => {
    // If we're not removing the item, restore the UI
    if (quantity > 0) {
      if (input) {
        input.value = quantity;
        input.classList.remove('loading');
        input.disabled = false;
      }
      
      // Update minus button disabled state
      if (minusButton) {
        minusButton.disabled = quantity <= 1;
      }
      
      if (plusButton) {
        plusButton.disabled = false;
      }
    }
    
    // Update the entire cart
    updateCartCount();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    
    // Restore UI on error
    if (input) {
      input.classList.remove('loading');
      input.disabled = false;
    }
    if (minusButton) minusButton.disabled = false;
    if (plusButton) plusButton.disabled = false;
    if (itemElement) itemElement.style.opacity = '1';
  });
}

// Initialize subscribe buttons
function initSubscribeButtons() {
  const subscribeButtons = document.querySelectorAll('.pdp-skincare-button');
  
  subscribeButtons.forEach(button => {
    // If button has no href or href is '#', make it open newsletter modal
    if (!button.href || button.href.endsWith('#')) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Open newsletter modal
        if (typeof openNewsletterModal === 'function') {
          openNewsletterModal();
        }
      });
    }
  });
}

// Initialize newsletter forms
function initNewsletterForms() {
  const newsletterForms = document.querySelectorAll('form[id*="newsletter"], .pdp-newsletter form:not(.klaviyo-api-form)');
  
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const submitButton = form.querySelector('button[type="submit"]');
      const emailInput = form.querySelector('input[type="email"]');
      
      if (!emailInput || !emailInput.value) {
        alert('Please enter a valid email address');
        return;
      }
      
      // Set loading state
      const originalText = submitButton ? submitButton.textContent : '';
      if (submitButton) {
        submitButton.textContent = 'Subscribing...';
        submitButton.disabled = true;
      }
      
      // Submit the form via AJAX
      const formData = new FormData(form);
      
      fetch(form.action || '/contact', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (response.ok) {
          // Success
          if (submitButton) {
            submitButton.textContent = 'Subscribed!';
          }
          
          // Clear the form
          if (emailInput) {
            emailInput.value = '';
          }
          
          // Show success message
          const successMessage = document.createElement('div');
          successMessage.style.cssText = 'color: green; font-size: 12px; margin-top: 10px; text-align: center;';
          successMessage.textContent = 'Thanks for subscribing! You\'ll hear from us soon.';
          form.appendChild(successMessage);
          
          // Remove success message after 5 seconds
          setTimeout(() => {
            if (successMessage.parentNode) {
              successMessage.parentNode.removeChild(successMessage);
            }
          }, 5000);
        } else {
          throw new Error('Subscription failed');
        }
      })
      .catch(error => {
        console.error('Newsletter subscription error:', error);
        if (submitButton) {
          submitButton.textContent = 'Error - Try Again';
        }
      })
      .finally(() => {
        // Reset button after delay
        setTimeout(() => {
          if (submitButton) {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }
        }, 3000);
      });
    });
  });
}

// Helper function to format money
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
} 